import { css } from 'styled-components'

export const safeAreaTopPadding = css`
  padding-top: var(--safe-area-top, 0px);
`
